const forge = require('node-forge');
const { Buffer } = require('buffer');

const encrypt = (content) => {
  const VUE_APP_CPK_PUK = process.env.VUE_APP_CPK_PUK;
  const VUE_APP_CPK_SCH = process.env.VUE_APP_CPK_SCH;
  const VUE_APP_CPK_ALG = process.env.VUE_APP_CPK_ALG;

  const publicKey = Buffer.from(VUE_APP_CPK_PUK, 'base64').toString('ascii');
  const public_key = forge.pki.publicKeyFromPem(publicKey);

  const iv = forge.random.getBytesSync(16);
  const key = forge.random.getBytesSync(32);

  const encryptedKey = public_key.encrypt(Buffer.from(key).toString('base64'), VUE_APP_CPK_SCH);

  const buffer = forge.util.createBuffer(content, 'utf8');
  const cipher = forge.cipher.createCipher(VUE_APP_CPK_ALG, key);

  cipher.start({ iv });
  cipher.update(buffer);
  cipher.finish();

  const payload = {
    iv: forge.util.encode64(iv),
    key: forge.util.encode64(encryptedKey),
    cipher: forge.util.encode64(cipher.output.data),
  };

  return JSON.stringify(payload);
};

module.exports = encrypt;
